import React from 'react'

const Footer = () => {
    return (
        <div className="text-center pt-3" >
            <footer className="container-fluid sticky-bottom">
            <h4 className='text-footer pt-5'>&copy; 2023</h4>
                <h5 className='text-footer pt-2'>Todas las imágenes pertenecen a unsplash.com</h5>
            </footer>
        </div>
    )
}

export default Footer
